import {Mapper} from '@s-ui/domain'

export class GetConfigFieldsFormMapper extends Mapper {
  constructor({config, configFieldFormVOFactory}) {
    super()
    this._config = config
    this._configFieldFormVOFactory = configFieldFormVOFactory
    this._configFields = this._config.get('form').configFields
  }

  _getMaxLengthConstraint({value}) {
    return {
      property: {
        maxlength: value
      }
    }
  }

  _getMinLengthConstraint({message, value}) {
    return {
      message,
      property: {
        minlength: value
      }
    }
  }

  _getNotNullConstraint({message}) {
    return {
      message,
      property: {
        notnull: ''
      }
    }
  }

  _getPatternConstraint({message, pattern}) {
    return {
      message,
      property: {pattern}
    }
  }

  _constraintsGenerator = {
    maxLength: this._getMaxLengthConstraint,
    minLength: this._getMinLengthConstraint,
    notNull: this._getNotNullConstraint,
    pattern: this._getPatternConstraint
  }

  _mapFieldConstraints(customConstraints = {}) {
    const constraints = []
    for (const customConstraint in customConstraints) {
      const constraint = this._constraintsGenerator[customConstraint](customConstraints[customConstraint])
      if (constraint) {
        constraints.push(constraint)
      }
    }
    return constraints
  }

  _getConfigField({customConstraints, field}) {
    const {constraints, ...configField} = this._configFields[field]
    return {
      ...configField,
      constraints: this._mapFieldConstraints(customConstraints || constraints)
    }
  }

  map(fields) {
    return fields.map(({field, customConstraints, customProps}) => {
      return this._configFieldFormVOFactory({
        ...this._getConfigField({customConstraints, field}),
        ...customProps
      })
    })
  }
}
